import { Table } from 'dexie'
import { IDeviceInfo } from './deviceInfo.service'
import { DB_NAME_SETTINGS, IndexDbService } from './indexDb.service'

export class SettingsIndexDbService extends IndexDbService {
  deviceInfo!: Table<IDeviceInfo, string>

  constructor() {
    super(DB_NAME_SETTINGS)

    this.db.version(1).stores({
      deviceInfo: 'id',
    })

    // Instantiate all tables here
    this.deviceInfo = this.db.table('deviceInfo')

    this.db.open()
  }
}
